import components from '@/components';
import { RouteRecordRaw } from 'vue-router';
import type { RouteRecord } from './route.d'
import pinia from '@/store'
import { useCommon } from "@/store/useCommon";
const storeCommon = useCommon(pinia)

// export const menuList: RouteRecord[] = [
//   {
//     name: 'Mo2',
//     path: '/on-demand-content',
//     redirect: '/on-demand-content/film-review',
//     meta: {
//       title: '点播内容',
//       icon: require('@/assets/imgs/ic_vod.png')
//     },
//     children: [
//       {
//         name: 'FilmReview',
//         path: '/on-demand-content/film-review',
//         meta: {
//           title: '影片审核',
//           icon: ''
//         },
//         component: () => import(/* webpackChunkName: "FilmReview" */ '@/views/onDemandContent/FilmReview/index.vue')
//       },
//       {
//         name: 'FilmReviewEdit',
//         path: '/on-demand-content/film-review/edit',
//         meta: {
//           title: '影片审核编辑',
//           icon: '',
//           hidden: true,
//           activeMenu: '/on-demand-content/film-review'
//         },
//         component: () => import(/* webpackChunkName: "FilmReviewEdit" */ '@/views/onDemandContent/FilmReview/edit.vue')
//       },
//       {
//         name: 'FilmMange',
//         path: '/on-demand-content/film-mange',
//         meta: {
//           title: '影片管理',
//           icon: ''
//         },
//         component: () => import(/* webpackChunkName: "FilmMange" */ '@/views/onDemandContent/FilmMange/index.vue')
//       },
//       {
//         name: 'SeriesFilm',
//         path: '/on-demand-content/series-film',
//         meta: {
//           title: '系列影片',
//           icon: ''
//         },
//         component: () => import(/* webpackChunkName: "SeriesFilm" */ '@/views/onDemandContent/SeriesFilm/index.vue')
//       },

//     ]
//   },


//   {
//     name: 'Operating',
//     path: '/operating',
//     redirect: '/operating/product-operating',
//     meta: {
//       title: '运营管理',
//       icon: require('@/assets/imgs/ic_operate.png')
//     },
//     children: [
//       {
//         name: 'ProductOperating',
//         path: '/operating/product-operating',
//         meta: {
//           title: '产品运营',
//           icon: ''
//         },
//         component: () => import(/* webpackChunkName: "ProductOperating" */ '@/views/operating/productOperations/index.vue')
//       },
//       {
//         name: 'Channel',
//         path: '/operating/product-operating/channel',
//         meta: {
//           title: '频道分类',
//           icon: '',
//           hidden: true,
//           activeMenu: '/operating/product-operating'
//         },
//         component: () => import(/* webpackChunkName: "Channel" */ '@/views/operating/productOperations/Channel/index.vue')
//       },
//       {
//         name: 'ChannelContent',
//         path: '/operating/product-operating/channel/channel-content',
//         meta: {
//           title: '频道内容',
//           icon: '',
//           hidden: true,
//           activeMenu: '/operating/product-operating'
//         },
//         component: () => import(/* webpackChunkName: "ChannelContent" */ '@/views/operating/productOperations/ChannelContent/index.vue')
//       },
//       {
//         name: 'AddChannel',
//         path: '/operating/product-operating/channel/add-channel',
//         meta: {
//           title: '添加频道',
//           icon: '',
//           hidden: true,
//           activeMenu: '/operating/product-operating'
//         },
//         component: () => import(/* webpackChunkName: "AddChannel" */ '@/views/operating/productOperations/AddChannel/index.vue')
//       },
//       {
//         name: 'OnDemand',
//         path: '/operating/product-operating/on-demand',
//         meta: {
//           title: '点播分类',
//           icon: '',
//           hidden: true,
//           activeMenu: '/operating/product-operating'
//         },
//         component: () => import(/* webpackChunkName: "OnDemand" */ '@/views/operating/productOperations/OnDemand/index.vue')
//       },
//       // {
//       //   name: 'OnDemandContent',
//       //   path: '/operating/product-operating/on-demand/on-demand-content',
//       //   meta: {
//       //     title: '点播内容',
//       //     icon: '',
//       //     hidden: true,
//       //     activeMenu: '/operating/product-operating'
//       //   },
//       //   component: () => import(/* webpackChunkName: "OnDemandContent" */ '@/views/operating/productOperations/OnDemand/onDemandContent/index.vue')
//       // },
//       // {
//       //   name: 'PaidContent',
//       //   path: '/operating/product-operating/on-demand/paid-content',
//       //   meta: {
//       //     title: '内容付费设置',
//       //     icon: '',
//       //     hidden: true,
//       //     activeMenu: '/operating/product-operating'
//       //   },
//       //   component: () => import(/* webpackChunkName: "PaidContent" */ '@/views/operating/productOperations/OnDemand/onDemandContent/PaidContent.vue')
//       // },
//       // {
//       //   name: 'AddFilm',
//       //   path: '/operating/product-operating/on-demand/add-film',
//       //   meta: {
//       //     title: '添加影片',
//       //     icon: '',
//       //     hidden: true,
//       //     activeMenu: '/operating/product-operating'
//       //   },
//       //   component: () => import(/* webpackChunkName: "AddFilm" */ '@/views/operating/productOperations/OnDemand/onDemandContent/AddFilm.vue')
//       // },
//       {
//         name: 'AddSeries',
//         path: '/operating/product-operating/on-demand/add-series',
//         meta: {
//           title: '添加系列',
//           icon: '',
//           hidden: true,
//           activeMenu: '/operating/product-operating'
//         },
//         component: () => import(/* webpackChunkName: "AddSeries" */ '@/views/operating/productOperations/OnDemand/onDemandContent/AddSeries.vue')
//       },
//       {
//         name: 'OperatingPlan',
//         path: '/operating/operating-plan',
//         meta: {
//           title: '运营方案',
//           icon: '',
//         },
//         component: () => import(/* webpackChunkName: "OperatingPlan" */ '@/views/operating/operatingPlan/index.vue'),
//       },
//       {
//         name: 'PlanAction',
//         path: '/operating/operating-plan/plan-action',
//         meta: {
//           title: '新增运营方案',
//           icon: '',
//           activeMenu: '/operating/operating-plan',
//           hidden: true
//         },
//         component: () => import(/* webpackChunkName: "PlanAction" */ '@/views/operating/operatingPlan/PlanAction/index.vue'),
//       },
//       {
//         name: 'TopicManagement',
//         path: '/operating/TopicManagement',
//         meta: {
//           title: '主题管理',
//           icon: '',
//           activeMenu: '/operating/TopicManagement',
//         },
//         component: () => import(/* webpackChunkName: "OperatingPlan" */ '@/views/operating/TopicManagement/index.vue'),
//       },
//       {
//         name: 'LiveCategory',
//         path: '/operating/product-operating/live-category',
//         meta: {
//           title: '直播分类',
//           icon: '',
//           hidden: true,
//           activeMenu: '/operating/product-operating'
//         },
//         component: () => import(/* webpackChunkName: "LiveChannelCategory" */ '@/views/operating/productOperations/LiveChannelCategory/index.vue')
//       },
//       {
//         name: 'RecommendOperation',
//         path: '/operating/product-operating/recommend-operation',
//         meta: {
//           title: '推荐管理',
//           icon: '',
//           hidden: true,
//           activeMenu: '/operating/product-operating'
//         },
//         component: () => import(/* webpackChunkName: "RecommendOperation" */ '@/views/operating/productOperations/RecommendOperation/index.vue')
//       },
//       {
//         name: 'LiveContent',
//         path: '/operating/product-operating/live-category/live-content',
//         meta: {
//           title: '直播内容',
//           icon: '',
//           hidden: true,
//           activeMenu: '/operating/product-operating'
//         },
//         component: () => import(/* webpackChunkName: "LiveContent" */ '@/views/operating/productOperations/LiveChannelCategory/liveContent.vue')
//       },
//       {
//         name: 'AddChannelToContent',
//         path: '/operating/product-operating/live-category/live-content/add-channel',
//         meta: {
//           title: '添加频道',
//           icon: '',
//           hidden: true,
//           activeMenu: '/operating/product-operating'
//         },
//         component: () => import(/* webpackChunkName: "LiveContent" */ '@/views/operating/productOperations/LiveChannelCategory/addChanneToContent.vue')
//       },
//       // {
//       //   name: 'NewTopic',
//       //   path: '/operating/new-topic',
//       //   meta: {
//       //     title: '新增主题',
//       //     icon: '',
//       //     hidden: true
//       //   },
//       // component: () => import(/* webpackChunkName: "OperatingPlan" */ '@/views/operating/TopicManagement/newTopic/index.vue'),
//       // },
//     ]
//   },


//   {
//     name: 'LiveChannel',
//     path: '/live/channel-review',
//     redirect: '/operating/product-operating',
//     meta: {
//       title: '直播频道',
//       icon: require('@/assets/imgs/ic_live.png')
//     },
//     children: [
//       {
//         name: 'ChannelReview',
//         path: '/live/channel-review',
//         meta: {
//           title: '频道审核',
//           icon: ''
//         },
//         component: () => import(/* webpackChunkName: "ChannelReview" */ '@/views/liveChannel/channelReview/index.vue')
//       },
//       {
//         name: 'ChannelManagement',
//         path: '/live/channel-management',
//         meta: {
//           title: '频道管理',
//           icon: ''
//         },
//         component: () => import(/* webpackChunkName: "ChannelManagement" */ '@/views/liveChannel/channelManage/index.vue')
//       }
//     ]
//   },
//   {
//     name: 'ContentParamSetting',
//     path: '/contentParamSetting',
//     redirect: '/operating/product-operating',
//     meta: {
//       title: '内容参数配置',
//       icon: require('@/assets/imgs/ic_content.png'),
//       keepAlive:1
//     },
//     children: [
//       {
//         name: 'liveParams',
//         path: '/liveParams',
//         meta: {
//           title: '直播参数',
//           icon: ''
//         },
//         component:  () => import(/* webpackChunkName: "liveParams" */ '@/views/contentParamSetting/liveParams/index.vue')
//       },
//       {
//         name: 'categoryAttribute',
//         path: '/contentParamSetting/category-attribute',
//         meta: {
//           title: '分类属性'
//         },
//         children: [
//           {
//             name: 'categoryAttribute',
//             path: '/contentParamSetting/category-attribute/live',
//             meta: {
//               title: '直播分类属性',
//               icon: '',
//             },
//             component: () => import(/* webpackChunkName: "categoryAttribute" */ '@/views/contentParamSetting/categoryAttribute/liveCategoryAttribute/index.vue')
//           },
//           {
//             name: 'VodCategoryAttribute',
//             path: '/contentParamSetting/category-attribute/vod',
//             meta: {
//               title: '点播分类属性',
//               icon: '',
//             },
//             component: () => import(/* webpackChunkName: "VodCategoryAttribute" */ '@/views/contentParamSetting/categoryAttribute/VodCategoryAttribute/index.vue')
//           }
//         ]
//       },
//       {
//         name: 'actorsAndDirectors',
//         path: '/contentParamSetting/actorsAndDirectors',
//         meta: {
//           title: '演职人员'
//         },
//         children: [
//           {
//             name: 'Actor',
//             path: '/contentParamSetting/actorsAndDirectors/actor',
//             meta: {
//               title: '演员',
//               icon: '',
//             },
//             component: () => import(/* webpackChunkName: "Actor" */ '@/views/contentParamSetting/actorsAndDirectors/Actor/index.vue')
//           },
//           {
//             name: 'Director',
//             path: '/contentParamSetting/actorsAndDirectors/director',
//             meta: {
//               title: '导演',
//               icon: '',
//             },
//             component: () => import(/* webpackChunkName: "Director" */ '@/views/contentParamSetting/actorsAndDirectors/Director/index.vue')
//           }
//         ]
//       }
//     ]
//   }
// ]

// 获取符合 vue-router 的路由数据，对菜单数据进行平展，将具有 children 属性的对象抛弃，将 children 下的对象平展到最外层
function getRoutesList(menuList) {
  menuList = menuList || [];
  // 存放处理后的数据
  let processList = [];
  menuList.forEach(item => {
    if (item.hasOwnProperty('children')) {
      // 只要配置了children 属性，无论这个属性是否有值，都认为这是父菜单，不会存进路由
      // 做一层浅复制，为了删除 children 属性时，不影响原始数据
      let itemCopy = Object.assign({}, item, {});
      // 删除 itemCopy children 属性
      delete itemCopy.children
      // 先将父路由添加进来
      processList.push(itemCopy);
      // 再处理字路由
      if (item.children && item.children.length > 0) {
        // 递归处理
        processList = processList.concat(getRoutesList(item.children));
      }
    } else {
      // 子菜单
      processList.push(item);
    }
  });
  return processList;
}


function importComponent(menuList) {
  menuList = menuList || [];
  let newList = [];
  newList = menuList.map(item => {
    if (item.component) {
      try {
        item.component = require(`@/views/${item.component}/index.vue`).default
      }
      catch (ex) {
        console.log(item.component, "页面不存在")
      }
    }
    if (item.children && item.children.length > 0) {
      // 递归处理
      item.children = importComponent(item.children)
    }
    return item
  })
  return newList;
}

let cmsRoute: RouteRecord[]
// 拿到基座发过来的路由数据
(window as any)?.microApp?.addDataListener((data: any) => {
  // console.log(data.user.menuList)
  if ((data.user && data.user.menuList && data.user.menuList.length) || (data.menuList && data.menuList.length > 0)) {
    cmsRoute = JSON.parse(JSON.stringify(((data.user && data.user.menuList) || data.menuList).filter(item => item.path === '/cms/:page*')[0].children))
    cmsRoute = importComponent(cmsRoute)
  }

}, true)

export const menuList: RouteRecord[] = cmsRoute